"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.row = exports.icon = exports.emptyCell = void 0;

const emptyCell = () => ({
  width: 8
});

exports.emptyCell = emptyCell;

const icon = () => ({
  fontSize: 16,
  '& svg': {
    display: 'block'
  }
});

exports.icon = icon;

const row = () => ({
  ':hover': {
    '& [data-name="actions"]': {
      display: 'flex'
    }
  },
  nested: {
    '& [data-name="actions"]': {
      display: 'none'
    }
  }
});

exports.row = row;
//# sourceMappingURL=ScripTable.style.js.map